import { HttpInterceptorFn } from '@angular/common/http';
import { environment } from '../../environments/environment';

const EMPTY_BEARER = /^Bearer\s+(null|undefined)?\s*$/i;

/**
 * Sessão do browser vai no cookie HttpOnly da API.
 * Bearer `null` (serviços que ainda leem getToken()) é removido para o cookie autenticar.
 */
export const sessionCookieInterceptor: HttpInterceptorFn = (req, next) => {
  if (!req.url.startsWith(environment.apiUrl)) {
    return next(req);
  }

  let headers = req.headers;
  const authorization = headers.get('Authorization');
  if (authorization && EMPTY_BEARER.test(authorization)) {
    headers = headers.delete('Authorization');
  }
  if (!headers.has('X-Wosi-Client')) {
    headers = headers.set('X-Wosi-Client', 'web');
  }

  return next(req.clone({ headers, withCredentials: true }));
};
